module.exports = __webpack_public_path__ + "img/cross-pink.9680ff31.svg";